/**
 * Validiert einen Tag gegen das Pattern `<achse>-<wert>`.
 *
 * Regeln:
 * - Nur ASCII-Kleinbuchstaben (a-z), Ziffern (0-9) und Bindestriche
 * - Mindestens ein Bindestrich, mit nicht-leeren Segmenten davor und danach
 * - Keine Umlaute, keine Leerzeichen, keine Unterstriche, keine Großbuchstaben
 *
 * Beispiele gültig:  "hauttyp-trocken", "fokus-feuchtigkeit", "tierart-hund",
 *                    "rebsorte-pinot-noir" (mehrteiliger Wert erlaubt)
 * Beispiele ungültig: "Hauttyp-trocken" (Großbuchstabe),
 *                     "hauttyp_trocken" (Unterstrich),
 *                     "hauttyp" (kein Bindestrich),
 *                     "-hauttyp-trocken" (führender Bindestrich)
 */
export function isValidTag(tag: string): boolean {
  if (!tag || tag.length === 0) return false;
  return /^[a-z0-9]+(-[a-z0-9]+)+$/.test(tag);
}
